import { ChangeDetectionStrategy, Component, ElementRef, ViewEncapsulation } from '@angular/core';
import { AppTextService } from '@fi-shared/app-text';
import { FiFormHelperService } from '@fi-shared/fi-form-shared/fi-form-helper.service';
import { IContentLanguageLabelModel } from '@fi-shared/fi-content-language-shared/fi-content-language-shared';
import { FiFormQuestionBase } from '@fi-app/fi-form/fi-form-edit/fi-form-edit-form/fi-form-question-base';
import { FiComponentsContainer } from '@fi-shared/fi-components-container';
import { FiBrowserEventsService } from '@fi-shared/fi-shared-services/fi-browser-events.service';

@Component({
    selector: 'fi-form-attachment-element',
    templateUrl: './fi-form-attachment-element.component.html',
    styleUrls: [
        './fi-form-attachment-element.component.scss',
        '../fi-form-text-question/fi-form-text-question.component.scss',
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    providers: [{ provide: FiComponentsContainer, useExisting: FiFormAttachmentElementComponent }],
    host: { class: 'fi-file-attachment-element' },
    standalone: false,
})
export class FiFormAttachmentElementComponent extends FiFormQuestionBase {
    constructor(
        fiBrowserEventsService: FiBrowserEventsService,
        elementRef: ElementRef,
        formHelperService: FiFormHelperService,
        private appTextService: AppTextService,
    ) {
        super(fiBrowserEventsService, elementRef, formHelperService);
    }

    getHeaderText(): string {
        const currentHeaderName = this.question.Names.find((name: IContentLanguageLabelModel) => {
            return name.ContentLanguageId === this.selectedLanguageId;
        });
        return currentHeaderName && currentHeaderName.Value
            ? currentHeaderName.Value
            : this.appTextService.get('common.header');
    }

    getButtonText(): string {
        const currentButtonName = this.question.UploadButton.Names.find((name: IContentLanguageLabelModel) => {
            return name.ContentLanguageId === this.selectedLanguageId;
        });
        return currentButtonName && currentButtonName.Value
            ? currentButtonName.Value
            : this.appTextService.get('common.button_text');
    }
}
